import {BaseService} from "../../infrastructure/domain-services/base-service";
import {getRemoteConfig} from "firebase/remote-config";
import {firebase} from "../firebase/firebase";
import {fetchAndActivate, getBoolean, getNumber, getString} from 'firebase/remote-config';
// import {ARGS} from "../../core/bootstrap/args";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class RemoteConfigManager extends BaseService {
  remoteConfig;
  initCallback: Array<Function>;

  static injectables = [];

  constructor() {
    super();

    this.initCallback = [];
    this.remoteConfig = getRemoteConfig(firebase);
  }

  async init() {
    this.remoteConfig.settings.minimumFetchIntervalMillis = 0; //TODO change back to ARGS.FIREBASE_MIN_FETCH_INTERVAL;

    this.setDefault()

    await fetchAndActivate(this.remoteConfig)
      .then().catch(error => console.error(error));

    this.initCallback?.forEach((callback) => callback?.());
  }

  registerToInitCallback(callback) {
    this.initCallback.push(callback);
  }

  getBoolean(key: String) {
    return getBoolean(this.remoteConfig, key);
  }

  getNumber(key: String) {
    return getNumber(this.remoteConfig, key);
  }

  getString(key: String) {
    return getString(this.remoteConfig, key);
  }

  getJSON(key: String) {
    let json;

    try {
      const jsonString = getString(this.remoteConfig, key);
      json = jsonString ? JSON.parse(jsonString) : {}
    } catch {
      json = {};
    }

    return json;
  }

  async getAll() {
    let allParams = {};

    await fetchAndActivate(this.remoteConfig)
      .then(() => this.remoteConfig.getAll())
      .then(params => allParams = params)
      .catch(error => console.error(error));

    return allParams;
  }

  setDefault(remoteConfig) {
    const defaultConfig = {};

    if (remoteConfig?.length > 0) {
      remoteConfig.forEach((config) => defaultConfig[config.key] = config.default);

      Object.assign(this.remoteConfig.defaultConfig, defaultConfig);
    }
  }
}
